import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root ne postoji');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
  Service worker sluzi samo instalaciji na pocetni zaslon (vidi public/sw.js).
  U razvoju se ne registrira jer bi presretao Viteov HMR promet.
*/
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Instalacija je dodatak, ne uvjet rada portala. */
    });
  });
}
